import React, { useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate, TextFormat } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getEntity } from './fifth-wheel-history.reducer';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const FifthWheelHistoryDetail = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getEntity(props.match.params.id));
  }, []);

  const fifthWheelHistoryEntity = useAppSelector(state => state.fifthWheelHistory.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="fifthWheelHistoryDetailsHeading">
          <Translate contentKey="fleetSenseApp.fifthWheelHistory.detail.title">FifthWheelHistory</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{fifthWheelHistoryEntity.id}</dd>
          <dt>
            <span id="createdStart">
              <Translate contentKey="fleetSenseApp.fifthWheelHistory.createdStart">Created Start</Translate>
            </span>
          </dt>
          <dd>
            {fifthWheelHistoryEntity.createdStart ? <TextFormat value={fifthWheelHistoryEntity.createdStart} type="date" format={APP_DATE_FORMAT} /> : null}
          </dd>
          <dt>
            <span id="createdEnd">
              <Translate contentKey="fleetSenseApp.fifthWheelHistory.createdEnd">Created End</Translate>
            </span>
          </dt>
          <dd>{fifthWheelHistoryEntity.createdEnd ? <TextFormat value={fifthWheelHistoryEntity.createdEnd} type="date" format={APP_DATE_FORMAT} /> : null}</dd>
          <dt>
            <Translate contentKey="fleetSenseApp.fifthWheelHistory.vehicle">Vehicle</Translate>
          </dt>
          <dd>{fifthWheelHistoryEntity.vehicle ? fifthWheelHistoryEntity.vehicle.licensePlate : ''}</dd>
          <dt>
            <Translate contentKey="fleetSenseApp.fifthWheelHistory.trailer">Trailer</Translate>
          </dt>
          <dd>{fifthWheelHistoryEntity.trailer ? fifthWheelHistoryEntity.trailer.licensePlate : ''}</dd>
          <dt>
            <Translate contentKey="fleetSenseApp.fifthWheelHistory.company">Company</Translate>
          </dt>
          <dd>{fifthWheelHistoryEntity.company ? fifthWheelHistoryEntity.company.name : ''}</dd>
          <dt>
            <Translate contentKey="fleetSenseApp.fifthWheelHistory.positionStart">Position Start</Translate>
          </dt>
          <dd>{fifthWheelHistoryEntity.positionStart ? fifthWheelHistoryEntity.positionStart.id : ''}</dd>
          <dt>
            <Translate contentKey="fleetSenseApp.fifthWheelHistory.positionEnd">Position End</Translate>
          </dt>
          <dd>{fifthWheelHistoryEntity.positionEnd ? fifthWheelHistoryEntity.positionEnd.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/fifth-wheel-history" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/fifth-wheel-history/${fifthWheelHistoryEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default FifthWheelHistoryDetail;
